import {useEffect, useState} from 'react';

const LOG_PREFIX = '[useEntityCollectionRequirements]';
const BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token ? {Authorization: `Bearer ${token}`} : {};
}

function viewerQuery() {
    const userId = localStorage.getItem('user_id');
    return userId ? `?userId=${encodeURIComponent(userId)}` : '';
}

/**
 * Collection requirements linked to this KB entity (ICR/EEI/Gap/CT/CM/IIR).
 *
 * @param {string} entityId
 * @param {number} [refetchKey=0]
 */
export function useEntityCollectionRequirements(entityId, refetchKey = 0) {
    const [entityIdOut, setEntityIdOut] = useState(null);
    const [icrs, setIcrs] = useState([]);
    const [eeis, setEeis] = useState([]);
    const [gaps, setGaps] = useState([]);
    const [cts, setCts] = useState([]);
    const [cms, setCms] = useState([]);
    const [iirs, setIirs] = useState([]);
    const [loading, setLoading] = useState(!!entityId);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!entityId) {
            setEntityIdOut(null);
            setIcrs([]);
            setEeis([]);
            setGaps([]);
            setCts([]);
            setCms([]);
            setIirs([]);
            setLoading(false);
            setError(null);
            return undefined;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        fetch(`${BASE}/api/entities/${encodeURIComponent(entityId)}/collection-requirements${viewerQuery()}`, {
            headers: authHeaders(),
        })
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`${r.status}`))))
            .then((data) => {
                if (cancelled) return;
                setEntityIdOut(data?.entityId ?? entityId);
                setIcrs(Array.isArray(data?.icrs) ? data.icrs : []);
                setEeis(Array.isArray(data?.eeis) ? data.eeis : []);
                setGaps(Array.isArray(data?.gaps) ? data.gaps : []);
                setCts(Array.isArray(data?.cts) ? data.cts : []);
                setCms(Array.isArray(data?.cms) ? data.cms : []);
                setIirs(Array.isArray(data?.iirs) ? data.iirs : []);
                setLoading(false);
            })
            .catch((err) => {
                if (cancelled) return;
                console.error(`${LOG_PREFIX} Error:`, err);
                setError(err);
                setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [entityId, refetchKey]);

    const totalCount = icrs.length + eeis.length + gaps.length + cts.length + cms.length + iirs.length;

    return {entityId: entityIdOut, icrs, eeis, gaps, cts, cms, iirs, totalCount, loading, error};
}

export default useEntityCollectionRequirements;
